import _taggedTemplateLiteral from 'babel-runtime/helpers/taggedTemplateLiteral';

var _templateObject = _taggedTemplateLiteral(['\n  left: 0;\n  position: absolute;\n  top: 0;\n  width: 18px;\n  height: 18px;\n  z-index: 1;\n\n  svg {\n    position: absolute;\n    width: 100%;\n    height: 100%;\n  }\n'], ['\n  left: 0;\n  position: absolute;\n  top: 0;\n  width: 18px;\n  height: 18px;\n  z-index: 1;\n\n  svg {\n    position: absolute;\n    width: 100%;\n    height: 100%;\n  }\n']);

import styled from 'styled-components';

export var StyledWrapper = styled.div(_templateObject);